import { useQuery } from '@tanstack/vue-query'
import { cryptoWalletsKeys } from '../cryptoWalletsQueryKeys'
import { getVaspWalletStatusCounts } from '../vaspWalletEndpoints'

// Counts for the 4 VAISP wallet filter cards. Deliberately its own endpoint
// rather than three limit:1 list calls: the buckets are a single GROUP BY
// server-side, and the counts must stay constant while a card or a search
// narrows the list underneath them.
export function useVaspWalletStatusCountsQuery() {
  return useQuery({
    queryKey: cryptoWalletsKeys.vaspWalletStatusCounts(),
    queryFn: getVaspWalletStatusCounts,
  })
}
